import { render, staticRenderFns } from "./item.vue?vue&type=template&id=64e5816a&scoped=true"
import script from "./item.vue?vue&type=script&lang=js"
export * from "./item.vue?vue&type=script&lang=js"
import style0 from "./item.vue?vue&type=style&index=0&id=64e5816a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e5816a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\abroad-hrms-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64e5816a')) {
      api.createRecord('64e5816a', component.options)
    } else {
      api.reload('64e5816a', component.options)
    }
    module.hot.accept("./item.vue?vue&type=template&id=64e5816a&scoped=true", function () {
      api.rerender('64e5816a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/organization/newRole/roleCollapse/item.vue"
export default component.exports